module.exports = __webpack_public_path__ + "static/testimonial3-b1be115fa3ea24c3ed155ccff15ca8df.png";